"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletLinkAnalyticsAbstract = void 0;
/**
 * An abstract class used to send events to track metrics / analytics
 */
class WalletLinkAnalyticsAbstract {
}
exports.WalletLinkAnalyticsAbstract = WalletLinkAnalyticsAbstract;
